import { TeamsFx } from '@microsoft/teamsfx';
import React, { useState } from 'react';
import { Button } from '@fluentui/react-northstar';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { GRAPH_SCOPES } from '../utils/useGraph';

interface Props {
  signIn: () => void;
}

const useStyles = createUseStyles({
  root: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
  centered: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  centeredHorizontally: {
    position: 'relative',
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
  error: {
    marginTop: '10px',
    color: 'red',
  },
});

const AuthorizePermissions: React.VFC<Props> = ({ signIn }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const authorize = async () => {
    setLoading(true);
    setError(null);

    try {
      const teamsFx = new TeamsFx();
      await teamsFx.login(GRAPH_SCOPES);
      await signIn();
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.centered}>
        <p>{t('authorizePermissions.mustAuthorize')}</p>
        <Button onClick={authorize} disabled={loading}>
          {t('authorizePermissions.authorize')}
        </Button>
        <p className={classes.error}>{error}</p>
      </div>
    </div>
  );
};

export default AuthorizePermissions;
